import React from "react";
import { motion } from "framer-motion";
import styles from "./AboutContent.module.css";

const pageVariants = {
  initial: { opacity: 0, y: 20 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -20 },
};

const AboutContent = () => {
  return (
    <motion.div
      className={styles.container}
      variants={pageVariants}
      initial="initial"
      animate="in"
      exit="out"
      transition={{ duration: 0.5 }}
    >
      <p>self learner, creator, artist</p>
      <p>
        Istanbul based multi-disciplinary artist/creator who uses programming as
        a way to expand and reach beyond the horizon.
      </p>
    </motion.div>
  );
};

export default AboutContent;
